import { GlobalAxios } from "../axios/axios-config";
import {
  IMarComAutomationMessage,
  INewMarComAutomationMessages,
} from "../models/mar-com-automation-messages";

const CAMPAIGN_ROUTE =
  process.env.REACT_APP_AUTOMATIONS + "/api/v1/MarComAutomationMessage";

export const createMarComAutomationMessage = (
  params: INewMarComAutomationMessages
) => {
  return GlobalAxios.post(CAMPAIGN_ROUTE, params);
};

export const getMarComAutomationMessageById = (id: string) => {
  return GlobalAxios.get<IMarComAutomationMessage>(CAMPAIGN_ROUTE + "/" + id);
};

export const updateMarComAutomationMessage = ({
  id,
  item,
}: {
  id: string;
  item: INewMarComAutomationMessages;
}) => {
  return GlobalAxios.put(CAMPAIGN_ROUTE + "/" + id, item);
};
